import React from 'react';
import { Helmet } from 'react-helmet';
import './TermsServices.css';

const TermsServices = () => {
  return (
    <div className="terms-page">
      <Helmet>
        <title>Terms & Services | SamSoftix IT & Software Solutions</title>
        <meta
          name="description"
          content="Read SamSoftix Terms & Services. Learn about service policies, booking terms, payment conditions, and client responsibilities for IT solutions and software services."
        />
        <meta
          name="keywords"
          content="SamSoftix Terms, Service Policy, IT Services Pakistan, Software Solutions Terms, Booking Terms, Payment Policies"
        />
        <link rel="canonical" href="https://www.samsoftix.com/terms-services" />
      </Helmet>

      <section className="terms-hero">
        <h1>Terms & Services</h1>
        <p>Understand our policies, service terms, and client responsibilities before using SamSoftix services.</p>
      </section>

      <section className="terms-content">
        <article>
          <h2>1. Service Agreement</h2>
          <p>
            By booking services with SamSoftix, you agree to our terms and conditions. All projects and IT solutions are delivered according to the agreed scope and timeline.
          </p>
        </article>

        <article>
          <h2>2. Booking & Cancellation</h2>
          <p>
            Clients must provide accurate information during service booking. Cancellations or rescheduling should be communicated at least 24 hours before the scheduled service. Certain services may have non-refundable fees.
          </p>
        </article>

        <article>
          <h2>3. Payment Terms</h2>
          <p>
            Payments can be made via bank transfer, online payment, or other agreed methods. For projects, partial upfront payment may be required before work begins. Full payment is required before final delivery unless otherwise agreed.
          </p>
        </article>

        <article>
          <h2>4. Service Delivery</h2>
          <p>
            SamSoftix ensures professional delivery of IT solutions, software services, and remote support. Timelines may vary depending on project complexity, client input, and third-party dependencies.
          </p>
        </article>

        <article>
          <h2>5. Client Responsibilities</h2>
          <ul>
            <li>Provide accurate project details and requirements.</li>
            <li>Respond to queries in a timely manner.</li>
            <li>Ensure proper access to systems or resources for remote support.</li>
            <li>Maintain backups of important data before service execution.</li>
          </ul>
        </article>

        <article>
          <h2>6. Confidentiality</h2>
          <p>
            SamSoftix guarantees the confidentiality of client information. Sensitive data shared during projects or consultations will not be disclosed to third parties without consent.
          </p>
        </article>

        <article>
          <h2>7. Limitation of Liability</h2>
          <p>
            While SamSoftix strives for high-quality delivery, we are not liable for indirect losses, damages, or delays caused by client-side issues or external factors beyond our control.
          </p>
        </article>

        <article>
          <h2>8. Governing Law</h2>
          <p>
            These terms and services are governed by the laws of Pakistan. Any disputes arising will be addressed in the applicable jurisdiction.
          </p>
        </article>
      </section>
    </div>
  );
};

export default TermsServices;
